import type { PositionPath } from './soccerPositionPaths';

export const basketballPositionPaths: PositionPath[] = [
  {
    id: 'pos-point-guard',
    position: 'Point Guard',
    emoji: '🎯',
    shortDescription: 'The floor general',
    description: 'Learn to run the offense, create for others, and control the tempo.',
    lessonIds: [
      'bball-five-positions',
      'bball-court-layout',
      'bball-pick-and-roll',
      'bball-spacing',
      'bball-motion-offense',
    ],
    lessonRelevance: {
      'bball-five-positions': 'Understand every position so you can run the offense effectively.',
      'bball-court-layout': 'Know the court inside and out — where to drive, where to kick out.',
      'bball-pick-and-roll': 'The pick & roll is your primary weapon as a PG.',
      'bball-spacing': 'Great point guards understand how to use and create spacing.',
      'bball-motion-offense': 'Reading the defense and making decisions is the heart of motion offense.',
    },
  },
  {
    id: 'pos-shooting-guard',
    position: 'Shooting Guard',
    emoji: '🏹',
    shortDescription: 'The perimeter scorer',
    description: 'Master off-ball movement, catch-and-shoot, and creating your own shot.',
    lessonIds: [
      'bball-five-positions',
      'bball-court-layout',
      'bball-spacing',
      'bball-horns-sets',
    ],
    lessonRelevance: {
      'bball-five-positions': 'Know your role and how you fit with the other four positions.',
      'bball-court-layout': 'Understand where the best shooting spots are on the floor.',
      'bball-spacing': 'Great shooting guards find open space and move without the ball.',
      'bball-horns-sets': 'Learn how SGs get open looks from structured offensive sets.',
    },
  },
  {
    id: 'pos-small-forward',
    position: 'Small Forward',
    emoji: '⚡',
    shortDescription: 'The versatile wing',
    description: 'Be the swiss army knife — score, defend, and facilitate from the wing.',
    lessonIds: [
      'bball-five-positions',
      'bball-spacing',
      'bball-fast-break',
      'bball-man-vs-zone',
      'bball-motion-offense',
    ],
    lessonRelevance: {
      'bball-five-positions': 'The SF role demands versatility — understand what every position does.',
      'bball-spacing': 'Wings need to space the floor and attack closeouts.',
      'bball-fast-break': 'SFs are often the first to run in transition — learn to finish.',
      'bball-man-vs-zone': 'As a wing, your defensive versatility is crucial for guarding multiple positions.',
      'bball-motion-offense': 'SFs thrive in motion offenses with constant cutting and screening.',
    },
  },
  {
    id: 'pos-power-forward',
    position: 'Power Forward',
    emoji: '💪',
    shortDescription: 'The inside-out threat',
    description: 'Play in the post, pop for threes, and be a force on both ends.',
    lessonIds: [
      'bball-five-positions',
      'bball-pick-and-roll',
      'bball-spacing',
      'bball-horns-sets',
      'bball-man-vs-zone',
    ],
    lessonRelevance: {
      'bball-five-positions': 'Understand the modern PF role — it\'s evolved dramatically.',
      'bball-pick-and-roll': 'PFs are key screeners in the pick & roll — learn to roll and pop.',
      'bball-spacing': 'Modern PFs must stretch the floor and shoot from outside.',
      'bball-horns-sets': 'In Horns, the PF is positioned at the elbow for multiple actions.',
      'bball-man-vs-zone': 'PFs anchor the defensive interior in both man and zone.',
    },
  },
  {
    id: 'pos-center',
    position: 'Center',
    emoji: '🏔️',
    shortDescription: 'The anchor',
    description: 'Protect the rim, rebound, and dominate the paint on both ends.',
    lessonIds: [
      'bball-five-positions',
      'bball-court-layout',
      'bball-pick-and-roll',
      'bball-man-vs-zone',
      'bball-horns-sets',
    ],
    lessonRelevance: {
      'bball-five-positions': 'The center\'s role is evolving — understand the modern big.',
      'bball-court-layout': 'Know the paint, restricted area, and your zones of dominance.',
      'bball-pick-and-roll': 'As the screener, the pick & roll runs through you.',
      'bball-man-vs-zone': 'Centers are the last line of defense — rim protection is paramount.',
      'bball-horns-sets': 'Learn your role as the elbow big in structured half-court sets.',
    },
  },
];
